var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},_vm._l((_vm.info),function(message){return _c('div',{key:message.id,staticClass:"currency",domProps:{"innerHTML":_vm._s(message.message)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }